// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".badge[data-v-816540ec] {\n  background-color: var(--item-status-color);\n}\n[data-v-816540ec] .input-display label:last-child {\n  font-weight: 700 !important;\n}\n.section-title__extended[data-v-816540ec] .dot {\n  background-color: #fff !important;\n}\n.custom-counter-bg[data-v-816540ec] {\n  background-color: #ff7058;\n}", ""]);
// Exports
module.exports = exports;
